import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContainedButtonVariant } from '../../Buttons/ContainedButton'
import { TextButtonVariant } from '../../Buttons/TextButton'
import ConfirmWithButtonsModal from '../ConfirmWithButtonsModal'

interface RemoveSharedPlaylistModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  playlistName: string
}

const RemoveSharedPlaylistModal: React.FC<RemoveSharedPlaylistModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  playlistName,
}) => {
  const { t } = useTranslation()
  return (
    <ConfirmWithButtonsModal
      isOpen={isOpen}
      title={t('RemoveSharedPlaylistModal.Title', 'Remove Shared Playlist')}
      question={t(
        'RemoveSharedPlaylistModal.Question',
        'Remove "{{playlistName}}" from your view?',
        { playlistName }
      )}
      questionProps={{ variant: 'body1', align: 'center' }}
      confirmVariant={ContainedButtonVariant.YesRemove}
      cancelVariant={TextButtonVariant.Cancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}

export default RemoveSharedPlaylistModal
